module.exports = __webpack_public_path__ + "img/dance.c0d95a25.jpg";